<template>
	<div class="w-full px-5 py-5 leading-tight" :class="selected.bg">
		<div class="mb-3 flex">
			<div class="-mt-1">
				<svg v-if="icon == 'triangle_error'" class="inline-block align-middle mr-3" :class="selected.title" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path class="stroke-current" d="M10.29 3.85996L1.81999 18C1.64536 18.3024 1.55296 18.6453 1.55198 18.9945C1.551 19.3437 1.64148 19.6871 1.81442 19.9905C1.98735 20.2939 2.23672 20.5467 2.5377 20.7238C2.83868 20.9009 3.18079 20.9961 3.52999 21H20.47C20.8192 20.9961 21.1613 20.9009 21.4623 20.7238C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.85996C13.5317 3.56607 13.2807 3.32308 12.9812 3.15444C12.6817 2.98581 12.3437 2.89722 12 2.89722C11.6563 2.89722 11.3183 2.98581 11.0188 3.15444C10.7193 3.32308 10.4683 3.56607 10.29 3.85996V3.85996Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path class="stroke-current" d="M12 9V13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path class="stroke-current" d="M12 17H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<svg v-if="icon == 'info_circle'" class="inline-block align-middle mr-3" :class="selected.title" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<circle class="stroke-current" cx="12" cy="12" r="10"></circle>
					<line class="stroke-current" x1="12" y1="16" x2="12" y2="12"></line>
					<line class="stroke-current" x1="12" y1="8" x2="12.01" y2="8"></line>
				</svg>
				<svg v-if="icon == 'check_circle'" class="inline-block align-middle mr-3" :class="selected.title" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<path class="stroke-current" d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
					<polyline class="stroke-current" points="22 4 12 14.01 9 11.01"></polyline>
				</svg>
			</div>
			<div class="flex flex-col">
				<div class="flex-grow"></div>
				<h5 class="flex-grow inline-block text-2xl text-sans leading-none" :class="selected.title">{{ title }}</h5>
				<div class="flex-grow"></div>
			</div>
		</div>
		<p class="text-xl text-body leading-snug" :class="selected.description" v-html="body"></p>
	</div>
</template>

<script>
export default {
	name: 'ErrorBox',
	props: ["colour", "title", "body", "icon"],
	data() {
		return {
			colour_values: {
				red: {
					bg: 'bg-red-80',
					title: 'text-red-800',
					description: 'text-red-900'
				},
				green: {
					bg: 'bg-green-90',
					title: 'text-green-800',
					description: 'text-green-900'
				},
				purple: {
					bg: 'bg-purple-80',
					title: 'text-purple-800',
					description: 'text-purple-900'
				},
				blue: {
					bg: 'bg-blue-90',
					title: 'text-blue-800',
					description: 'text-blue-900'
				}
			},
			selected: {}
		}
	},
	created() {
		var colour = this.colour;

		if (!this.colour || !this.colour_values[colour]) {
			colour = "red";
		}

		this.selected = this.colour_values[colour];
	}
}
</script>